import { HeadingNode } from '@prezly/story-content-format';
import classNames from 'classnames';
import { Link2 } from 'lucide-react';
import type { HTMLAttributes } from 'react';

import { stringifySlateContent } from '@/lib/stringifySlateContent';
import { slugify } from '@/util/strings/slugify';

import { getNodeId } from '../../lib';

import alignment from '../alignment.module.scss';
import styles from './Heading.module.scss';

type Props = HTMLAttributes<HTMLHeadingElement> & {
    node: HeadingNode;
    level: 'h1' | 'h2' | 'h3';
};

export function Heading({ children, level, node, ...props }: Props) {
    const Tag = level;
    const id = getNodeId(node);

    const className = classNames(props.className, styles.heading, {
        [alignment.left]: node.align === HeadingNode.Alignment.LEFT,
        [alignment.center]: node.align === HeadingNode.Alignment.CENTER,
        [alignment.right]: node.align === HeadingNode.Alignment.RIGHT,

        [styles.h1]: level === 'h1',
        [styles.h2]: level === 'h2',
        [styles.h3]: level === 'h3',
    });

    return (
        <div
            data-heading={slugify(stringifySlateContent(node))}
            data-heading-level={level}
            {...props}
            id={id}
            className={classNames(styles.wrapper, {
                [styles.h1]: level === 'h1',
                [styles.h2]: level === 'h2',
                [styles.h3]: level === 'h3',
            })}
        >
            <a href={`#${id}`} className={styles.anchor} aria-label="Link to this section">
                <Link2 className={styles.icon} />
            </a>
            <Tag className={className}>{children}</Tag>
        </div>
    );
}
